import { Component, ViewChild } from "@angular/core";
import { IonFab, ModalController } from "@ionic/angular";
import { RideOpsUiService } from "../../configuration/services/rideops-ui.service";
import { LocationStateQuery } from "../../configuration/state/location-state.query";
import { CloseLocationComponent } from "../../modals/close-location/close-location.component";
import { DownLocationComponent } from "../../modals/down-location/down-location.component";

@Component({
	selector: "app-location-status",
	templateUrl: "./location-status.component.html",
	styleUrls: ["./location-status.component.scss"],
})
export class LocationStatusComponent {
	constructor(
		private modalController: ModalController,
		private locationStateQuery: LocationStateQuery,
		private rideOpsUi: RideOpsUiService,
	) {}
	@ViewChild(IonFab) fab!: IonFab;

	locationState$ = this.locationStateQuery.selectState$;

	closeLocation = async () => {
		const closeModal = await this.modalController.create({
			component: CloseLocationComponent,
			cssClass: "close-location-modal auto-height",
		});

		await closeModal.present();
		this.fab.close();
	};

	downLocation = async () => {
		const modal = await this.modalController.create({
			component: DownLocationComponent,
			cssClass: this.rideOpsUi.downLocationModalCssClass(),
		});

		await modal.present();
		this.fab.close();
	};
}
